import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/notice/notice-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-a4751d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      style: {"width":"14px"},
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("span", null, "消息通知")
  ])
], -1))
const _hoisted_2 = { class: "scroll-list-notice" }
const _hoisted_3 = { class: "list-item-title" }
const _hoisted_4 = { class: "text-title" }
const _hoisted_5 = { class: "text-time" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"height":"300px","margin":"5px","background-color":"#fff"} }
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center","height":"100%","width":"100%"} }
const _hoisted_10 = { style: {"color":"#333","font-size":"14px","font-weight":"400","padding":"10px 40px 10px 40px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleFilled = _resolveComponent("ExclamationCircleFilled")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_notice_dropdown = _resolveComponent("notice-dropdown")!

  return (_openBlock(), _createBlock(_component_notice_dropdown, {
    class: "action",
    count: _ctx.unreadCount,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.showDetails)
          ? (_openBlock(), _createBlock(_component_a_list, {
              key: 0,
              "item-layout": "horizontal",
              "data-source": _ctx.listData
            }, {
              renderItem: _withCtx(({ item }) => [
                _createVNode(_component_a_list_item, null, {
                  default: _withCtx(() => [
                    (!item.isRead)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 0,
                          dot: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ExclamationCircleFilled, { style: {"color":"#FFC565","font-size":"24px"} })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ExclamationCircleFilled, {
                          key: 1,
                          style: {"color":"#CCCCCC","font-size":"24px"}
                        })),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.content.title), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.datetime), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "text-desc",
                      style: _normalizeStyle({ color: !item.isRead ? '#1C91F0' : null }),
                      onClick: ($event: any) => (_ctx.getDetails(item))
                    }, "详情 >", 12, _hoisted_6)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["data-source"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ExclamationCircleFilled, { style: {"color":"#FFC565","font-size":"48px","top":"40px"} }),
                  _createVNode(_component_a_list, {
                    "item-layout": "horizontal",
                    "data-source": _ctx.detailDatas,
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item), 1)
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ]),
                _createElementVNode("div", {
                  class: "text-desc",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showDetails = false;_ctx.getNoticeData()}),
                  style: {"position":"absolute","right":"20px","top":"80px","cursor":"pointer"}
                }, " 返回 > ")
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["count", "loading"]))
}